import React, {useEffect, useState} from "react";
import localization from "assets/localization/localization";
import {Button} from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import '../main.css'
import Layout from 'components/sales/layout/layout';
import CustomModal from "../modal";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import Images from "../../../assets/images/imageData";
import { toast } from 'react-toastify';

const Projects = (
    {
        createProject,
        searchProject,
        searchProjectRes = {},
        projectRes = null,
        documentUploadUrlPublic,
        documentUrlDataPublic,
        updateProject,
        projectPricing,
        getPriceProject,
    }
) => {

    const [count, setCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false);
    const [inputPrice, setPriceValue] = useState([
        {
            0: "0",
            1: "0",
            2: "0",
            3: "0",
            4: "0",
            5: "0",
            6: "0",
            10: "0"
        }
    ]);

    const [inputList, setInputList] = useState(
        [
            {
                zone_selection_type: '',
                allow_get_my_car: false,
                allow_arrived_notification: false,
                allow_delivered_notification: false,
                allow_parked_notification: false,
                pre_payment: false,
                project_name: '',
                address: '',
                city: '',
                latitude: '',
                longitude: '',
                project_id: '',
                price: "",
                // is_platform_fee_allowed: false,
                platform_fee: '',
                is_saas: false,
                is_punched: false,
                is_progressive: false,
                is_image_skippable_site: false,
                eta: '',
                project_radius: '',
                sunday:'',
                monday:'',
                tues:'',
                wed:'',
                thur:'',
                fri:'',
                sat:'',
                base_hours:'',
                gmc:'',
                pmc:'',
                image_url:'',
                flow_type:'',
                show_pms_entered_vehicle:'',
                is_vrn_validation_required:'',
                allow_delivery_otp:'',
                is_insurance_allowed:'',
                allow_prebook_otp:'',
                is_prebooking_allowed:'',
                operational_start_time:'',
                operational_end_time:'',
                operational_days:'',
                pass_type_applicable:'',
                duty_mode:'',
                business_type:'',
                gmc_mandatory_count:'',
                project_type:'',
                active: true
            }
        ]
    );

    const [isSaasSet, setIsSaas] = useState(false)

    const [sundayprogressiveCharge, setSundayProgressiveCharge] = useState([
        {
            hours: "",
            price: ""
        }
    ])

    const [mondayprogressiveCharge, setMondayProgressiveCharge] = useState([
        {
            hours: "",
            price: ""
        }
    ])

    const [tuesdayprogressiveCharge, setTuesdayProgressiveCharge] = useState([
        {
            hours: "",
            price: ""
        }
    ])

    const [wednesdayprogressiveCharge, setWednesdayProgressiveCharge] = useState([
        {
            hours: "",
            price: ""
        }
    ])

    const [thurprogressiveCharge, setThurProgressiveCharge] = useState([
        {
            hours: "",
            price: ""
        }
    ])

    const [friprogressiveCharge, setFriProgressiveCharge] = useState([
        {
            hours: "",
            price: ""
        }
    ])

    const [satprogressiveCharge, setSatProgressiveCharge] = useState([
        {
            hours: "",
            price: ""
        }
    ])

    const [holidayprogressiveCharge, setHolidayProgressiveCharge] = useState([
        {
            hours: "",
            price: ""
        }
    ])

    const [inputImage, setImageList] = useState([{url: "", content:""}]);
    const [baseHours, setBaseHours] = useState([{
        0: "0",
        1: "0",
        2: "0",
        3: "0",
        4: "0",
        5: "0",
        6: "0",
        10: "0"
    }])
    const [pmcAllowedMethod, setPmcAllowedMethod] = useState([])
    const [pmcAutoAllowedMethod, setAutoPmcAllowedMethod] = useState([])
    const [gmcAllowedMethod, setGmcAllowedMethod] = useState([])
    const [editProjectButtonToggle, setEditProjectButtonToggle] = useState(false)
    const [freezProjectIdSection, setFreezProjectIdSection] = useState(false)
    const [operationalDays, setOperationalDays] = useState([])
    const [isPlatformFeeAllowed, setIsPlatformFeeAllowed] = useState(false)

    const handleImageContent = (val, index) => {
        const list = [...inputImage]
        list[index]['content'] = val
        setImageList([...list])
    }

    const handleSundayProgressiveChargeValue = (val, key, index) => {
        const list = [...sundayprogressiveCharge];
        list[index][key] = val;
        setSundayProgressiveCharge([...list]);
    }

    const handleSundayProgressiveChargeValueRemove = index => {
        const list = [...sundayprogressiveCharge];
        list.splice(index, 1);
        setSundayProgressiveCharge(list);
    }

    const handleSundayProgressiveChargeValueAdd = () => {
        setSundayProgressiveCharge(
            [
                ...sundayprogressiveCharge, {
                hours: "",
                price: ""
            }
            ]
        )
    }

    const handleMondayProgressiveChargeValue = (val, key, index) => {
        const list = [...mondayprogressiveCharge];
        list[index][key] = val;
        setMondayProgressiveCharge([...list]);
    }

    const handleMondayProgressiveChargeValueRemove = index => {
        const list = [...mondayprogressiveCharge];
        list.splice(index, 1);
        setMondayProgressiveCharge(list);
    }

    const handleMondayProgressiveChargeValueAdd = () => {
        setMondayProgressiveCharge(
            [
                ...mondayprogressiveCharge, {
                hours: "",
                price: ""
            }
            ]
        )
    }

    const handleTuesdayProgressiveChargeValue = (val, key, index) => {
        const list = [...tuesdayprogressiveCharge];
        list[index][key] = val;
        setTuesdayProgressiveCharge([...list]);
    }

    const handleTuesdayProgressiveChargeValueRemove = index => {
        const list = [...tuesdayprogressiveCharge];
        list.splice(index, 1);
        setTuesdayProgressiveCharge(list);
    }

    const handleTuesdayProgressiveChargeValueAdd = () => {
        setTuesdayProgressiveCharge(
            [
                ...tuesdayprogressiveCharge, {
                hours: "",
                price: ""
            }
            ]
        )
    }

    const handleWedProgressiveChargeValue = (val, key, index) => {
        const list = [...wednesdayprogressiveCharge];
        list[index][key] = val;
        setWednesdayProgressiveCharge([...list]);
    }

    const handleWedProgressiveChargeValueRemove = index => {
        const list = [...wednesdayprogressiveCharge];
        list.splice(index, 1);
        setWednesdayProgressiveCharge(list);
    }

    const handleWedProgressiveChargeValueAdd = () => {
        setWednesdayProgressiveCharge(
            [
                ...wednesdayprogressiveCharge, {
                hours: "",
                price: ""
            }
            ]
        )
    }

    const handleThurProgressiveChargeValue = (val, key, index) => {
        const list = [...thurprogressiveCharge];
        list[index][key] = val;
        setThurProgressiveCharge([...list]);
    }

    const handleThurProgressiveChargeValueRemove = index => {
        const list = [...thurprogressiveCharge];
        list.splice(index, 1);
        setThurProgressiveCharge(list);
    }

    const handleThurProgressiveChargeValueAdd = () => {
        setThurProgressiveCharge(
            [
                ...thurprogressiveCharge, {
                hours: "",
                price: ""
            }
            ]
        )
    }

    const handleFriProgressiveChargeValue = (val, key, index) => {
        const list = [...friprogressiveCharge];
        list[index][key] = val;
        setFriProgressiveCharge([...list]);
    }

    const handleFriProgressiveChargeValueRemove = index => {
        const list = [...friprogressiveCharge];
        list.splice(index, 1);
        setFriProgressiveCharge(list);
    }

    const handleFriProgressiveChargeValueAdd = () => {
        setFriProgressiveCharge(
            [
                ...friprogressiveCharge, {
                hours: "",
                price: ""
            }
            ]
        )
    }

    const handleSatProgressiveChargeValue = (val, key, index) => {
        const list = [...satprogressiveCharge];
        list[index][key] = val;
        setSatProgressiveCharge([...list]);
    }

    const handleSatProgressiveChargeValueRemove = index => {
        const list = [...satprogressiveCharge];
        list.splice(index, 1);
        setSatProgressiveCharge(list);
    }

    const handleSatProgressiveChargeValueAdd = () => {
        setSatProgressiveCharge(
            [
                ...satprogressiveCharge, {
                hours: "",
                price: ""
            }
            ]
        )
    }

    const handleHolidayProgressiveChargeValue = (val, key, index) => {
        const list = [...holidayprogressiveCharge];
        list[index][key] = val;
        setHolidayProgressiveCharge([...list]);
    }

    const handleHolidayProgressiveChargeValueRemove = index => {
        const list = [...holidayprogressiveCharge];
        list.splice(index, 1);
        setHolidayProgressiveCharge(list);
    }

    const handleHolidayProgressiveChargeValueAdd = () => {
        setHolidayProgressiveCharge(
            [
                ...holidayprogressiveCharge, {
                hours: "",
                price: ""
            }
            ]
        )
    }

    const saveImage = (val, index) => {
        const list = [...inputImage]
        list[index]['url'] = val
        setImageList([...inputImage])
    }

    const handleImageAdd = () => {
        setImageList (
            [
                ...inputImage, {
                url: '',
                content:''
            }
            ]
        )
    }

    const handleImageRemove = index => {
        const list = [...inputImage];
        list.splice(index, 1);
        setImageList(list);
    }

    const handleBaseHour = (val, index) => {
        const list = [...baseHours]
        list[0][index] = val
        setBaseHours([...list])
    }

    const handleInputValue = (val, key) => {
        const list = [...inputList];
        list[0][key] = val;
        setInputList([...list]);
    };

    const handleInputPrice = (val, key) => {
        const list = [...inputPrice];
        list[0][key] = parseInt(val);
        setPriceValue([...list]);
    }

    const handleOnSubmitSearch = async () => {
        let inputValues = inputList[0]
        if (inputValues.project_id !== "") {
            setIsLoading(true);
            await searchProject(inputValues.project_id, editProjectButtonToggle)
            await searchProject(inputValues.project_id, editProjectButtonToggle)
            if(editProjectButtonToggle){
                await getPriceProject(inputValues.project_id)
            }
            setIsLoading(false);
        }
    }

    const handleOnSubmitForm = async () => {
        // let inputValues = inputList[0]
        const pmcMethods = [];
        pmcAllowedMethod.map( (val, index) => {
            pmcMethods[index] = val.name
        })

        const gmcMethods = [];
        const flowType = [];
        const operationalDay = [];

        gmcAllowedMethod.map( (val, index) => {
            gmcMethods[index] = val.name
        })

        operationalDays.map( (val, index) => {
            operationalDay[index] = val.id
        })

        const fieldNames = {
            "0": "Sunday",
            "1": "Monday",
            "2": "Tuesday",
            "3": "Wednesday",
            "4": "Thursday",
            "5": "Friday",
            "6": "Saturday",
            "10": "Holiday"
        };
        let hasBlankFields = false;
        
        // const hasBlankFields = data.some(item => item.hours === "" || item.price === "");

        const list = [...inputList];
        if (searchProjectRes.length > 0) {
            list[0]['pmc'] = pmcMethods
            list[0]['gmc'] = gmcMethods
            list[0]['operational_days'] = operationalDay
            list[0]['image_url'] = inputImage
            list[0]['project_name'] = list[0]['project_name'] === "" ? searchProjectRes[0].project.name : list[0]['project_name'];
            list[0]['address'] = list[0]['address'] === "" ? searchProjectRes[0].project.address : list[0]['address'];
            list[0]['city'] = list[0]['city'] === "" ? searchProjectRes[0].project.city : list[0]['city'];
            list[0]['latitude'] = list[0]['latitude'] === "" ? searchProjectRes[0].project.latitude.toString() : list[0]['latitude'];
            list[0]['longitude'] = list[0]['longitude'] ==="" ? searchProjectRes[0].project.longitude.toString() : list[0]['longitude'];
            list[0]['price'] = inputPrice[0]
            list[0]['sunday'] = sundayprogressiveCharge
            list[0]['monday'] = mondayprogressiveCharge
            list[0]['tues'] = tuesdayprogressiveCharge
            list[0]['wed'] = wednesdayprogressiveCharge
            list[0]['thur'] = thurprogressiveCharge
            list[0]['fri'] = friprogressiveCharge
            list[0]['sat'] = satprogressiveCharge
            list[0]['base_hours'] = baseHours[0]
            list[0]['holiday'] = holidayprogressiveCharge
            list[0]['active']=(list[0]['active'] == undefined && list[0]['active'] == null && list[0]['active'] == '')? searchProjectRes?.[0]?.project?.active: list?.[0]?.['active']
            setInputList([...list]);

            Object.keys(inputPrice[0]).forEach(key => {
                const value = inputPrice[0][key];
                if (value === "" || value === undefined || Number.isNaN(value)) {
                    toast.error(`Price for ${fieldNames[key]} is blank`);
                    hasBlankFields = true;
                }
            });

            Object.keys(baseHours[0]).forEach(key => {
                const value = baseHours[0][key];
                if (value === "" || value === undefined || Number.isNaN(value)) {
                    toast.error(`Base hours for ${fieldNames[key]} is blank`);
                    hasBlankFields = true;
                }
            });
            
            if(!hasBlankFields){
                if(editProjectButtonToggle){
                    setIsLoading(true);
                    await updateProject(inputList[0])
                    setIsLoading(false);
                    setCount(count + 1)
                } else {
                    setIsLoading(true);
                    await createProject(inputList[0])
                    setIsLoading(false);
                    setCount(count + 1)
                }
            }
        }
    }


    useEffect( () => {
        (async () => {
           await searchProject(0)
           if(editProjectButtonToggle){
            await getPriceProject(0)
           }
            setFreezProjectIdSection(false)
        })()
    }, [])

    const handleChange = (e, key) => {
        let isChecked = e.target.checked;
        console.log('is event',key)
        // eslint-disable-next-line no-unused-expressions
        key === 'is_progressive' && isChecked ? setIsSaas(true) :  ""
        if(key === 'is_event' && isChecked ){
            handleInputValue('event','project_type',)
        }else{
            handleInputValue('','project_type')
        }
        if(searchProjectRes[0].project?.project_config_json?.project_type=='event'){
            if(key === 'active' && isChecked ){
                handleInputValue(true,'active')
            }else{
                handleInputValue(false,'active')
            }
        }
        if(key === 'is_progressive' && !isChecked){
            if(!window.confirm('do you want to remove all progressive charge ?')){
                return false
            }
            setIsSaas(false)
            setSundayProgressiveCharge([
                {
                    hours: "",
                    price: ""
                }
            ])

            setMondayProgressiveCharge([
                {
                    hours: "",
                    price: ""
                }
            ])

            setTuesdayProgressiveCharge([
                {
                    hours: "",
                    price: ""
                }
            ])

            setWednesdayProgressiveCharge([
                {
                    hours: "",
                    price: ""
                }
            ])

            setThurProgressiveCharge([
                {
                    hours: "",
                    price: ""
                }
            ])

            setFriProgressiveCharge([
                {
                    hours: "",
                    price: ""
                }
            ])

            setSatProgressiveCharge([
                {
                    hours: "",
                    price: ""
                }
            ])

            setHolidayProgressiveCharge([
                {
                    hours: "",
                    price: ""
                }
            ])
        }
        // if(key === 'is_platform_fee_allowed' && isChecked) {
        //     setIsPlatformFeeAllowed(true)
        // }
        isChecked ? handleInputValue(true, key) : handleInputValue(false, key)
    }

    const handleSubmit = async (value) => {
        if(value){
            setEditProjectButtonToggle(true)
            let inputValues = inputList[0]
            if (inputValues.project_id !== "") {
                setIsLoading(true);
                await searchProject(inputValues.project_id, true)
                await searchProject(inputValues.project_id, true)
                await getPriceProject(inputValues.project_id)
                setIsLoading(false);
            }
        }else{
            window.location.reload();
        }
    }

    const headerBtns = () => {
        return (
            <>
                {!editProjectButtonToggle ?
                    <Button onClick={() => {handleSubmit(true)}} className="btn btn-primary">
                        { localization.editValetProject}
                        <img src={Images?.ArrowRight} alt="" />
                    </Button> :
                    <Button onClick={() => {handleSubmit(false)}} className="btn btn-primary">
                        { localization.addProject}
                        <img src={Images?.ArrowRight} alt="" />
                    </Button>
                }
            </>
        );
    };


    useEffect( () => {

        if(searchProjectRes !== [] && Object.keys(searchProjectRes).length > 0){
            setFreezProjectIdSection(true)
        }
        // will for update project
        if(searchProjectRes.length > 0){
            if(searchProjectRes[0].project?.site_images){
                setImageList(searchProjectRes[0].project?.site_images)
            } else if(searchProjectRes[0].project?.project_config_json?.site_images){
                setImageList(searchProjectRes[0].project?.project_config_json?.site_images)
            }

            if(searchProjectRes[0].project?.project_config_json){
                handleInputValue(searchProjectRes[0].project?.project_config_json.allow_arrived_notification, 'allow_arrived_notification')
                handleInputValue(searchProjectRes[0].project?.project_config_json.allow_get_my_car, 'allow_get_my_car')
                handleInputValue(searchProjectRes[0].project?.project_config_json.allow_delivered_notification, 'allow_delivered_notification')
                handleInputValue(searchProjectRes[0].project?.project_config_json.allow_parked_notification, 'allow_parked_notification')
                handleInputValue(searchProjectRes[0].project?.project_config_json.is_saas, 'is_saas')
                handleInputValue(searchProjectRes[0].project?.project_config_json.is_punched, 'is_punched')
                handleInputValue(searchProjectRes[0].project?.project_config_json.is_image_skippable_site, 'is_image_skippable_site')
                handleInputValue(searchProjectRes[0].project?.project_config_json.allow_delivery_otp, 'allow_delivery_otp')
                handleInputValue(searchProjectRes[0].project?.project_config_json.is_progressive, 'is_progressive')
                // handleInputValue(searchProjectRes[0].project?.project_config_json.is_platform_fee_allowed, 'is_platform_fee_allowed')
                handleInputValue(searchProjectRes[0].project?.project_config_json.platform_fee, 'platform_fee')
                handleInputValue(searchProjectRes[0].project?.project_config_json.is_prebooking_allowed, 'is_prebooking_allowed')
                handleInputValue(searchProjectRes[0].project?.project_config_json.is_insurance_allowed, 'is_insurance_allowed')
                handleInputValue(searchProjectRes[0].project?.project_config_json.is_vrn_validation_required, 'is_vrn_validation_required')
                handleInputValue(searchProjectRes[0].project?.project_config_json.show_pms_entered_vehicle, 'show_pms_entered_vehicle')
                handleInputValue(searchProjectRes[0].project?.project_config_json.allow_prebook_otp, 'allow_prebook_otp')
                handleInputValue(searchProjectRes[0].project?.project_config_json?.pass_type_applicable, 'pass_type_applicable')
                handleInputValue(searchProjectRes[0].project?.project_config_json?.duty_mode, 'duty_mode')
                handleInputValue(searchProjectRes[0].project?.project_config_json.gmc_mandatory_count, 'gmc_mandatory_count')
                handleInputValue(searchProjectRes[0].project?.project_config_json.operational_start_time, 'operational_start_time')
                handleInputValue(searchProjectRes[0].project?.project_config_json.operational_end_time, 'operational_end_time')
                handleInputValue(searchProjectRes[0].project?.project_config_json?.business_type, 'business_type')
                handleInputValue(searchProjectRes[0].project?.project_config_json?.flow_type, 'flow_type')
                handleInputValue(searchProjectRes[0].project?.project_config_json.operational_days, 'operational_days')
                handleInputValue(searchProjectRes[0].project?.active, 'active')
                setIsSaas(false)
                if(searchProjectRes[0].project?.project_config_json.is_progressive) {
                    setIsSaas(true)
                }
                // if(searchProjectRes[0].project?.project_config_json.is_platform_fee_allowed) {
                //     setIsPlatformFeeAllowed(true)
                // }
            }
        }
    }, [searchProjectRes])

    useEffect( () => {
        if(projectPricing && projectPricing?.data === undefined &&projectPricing !== [] && Object.keys(projectPricing).length > 0){
            setSundayProgressiveCharge(projectPricing?.sunday?.progressive_charge)
            setHolidayProgressiveCharge(projectPricing?.holiday?.progressive_charge)
            setMondayProgressiveCharge(projectPricing?.monday?.progressive_charge)
            setTuesdayProgressiveCharge(projectPricing?.tuesday?.progressive_charge)
            setWednesdayProgressiveCharge(projectPricing?.wednesday?.progressive_charge)
            setThurProgressiveCharge(projectPricing?.thurs?.progressive_charge)
            setFriProgressiveCharge(projectPricing?.friday?.progressive_charge)
            setSatProgressiveCharge(projectPricing?.sat?.progressive_charge)
            handleInputPrice(projectPricing?.sunday?.price, 0)
            handleInputPrice(projectPricing?.monday?.price, 1)
            handleInputPrice(projectPricing?.tuesday?.price, 2)
            handleInputPrice(projectPricing?.wednesday?.price, 3)
            handleInputPrice(projectPricing?.thurs?.price, 4)
            handleInputPrice(projectPricing?.friday?.price, 5)
            handleInputPrice(projectPricing?.sat?.price, 6)
            handleInputPrice(projectPricing?.holiday?.price, 10)

            handleBaseHour(projectPricing?.sunday?.base_hour, 0)
            handleBaseHour(projectPricing?.monday?.base_hour, 1)
            handleBaseHour(projectPricing?.tuesday?.base_hour, 2)
            handleBaseHour(projectPricing?.wednesday?.base_hour, 3)
            handleBaseHour(projectPricing?.thurs?.base_hour, 4)
            handleBaseHour(projectPricing?.friday?.base_hour, 5)
            handleBaseHour(projectPricing?.sat?.base_hour, 6)
            handleBaseHour(projectPricing?.holiday?.base_hour, 10)
        }
    }, [projectPricing])

    return (
        <>
            <Layout
                Buttons={headerBtns}
                isGoback
                isLoading={isLoading}
            >
                <div className="container-fluid">
                    <div className="card">
                        {projectRes !== null && projectRes?.response?.status !== 200 &&
                            <CustomModal msg={projectRes?.response?.message} click={count}/>}
                        {projectRes !== null && projectRes?.response?.status === 200 &&
                            <CustomModal msg={projectRes?.response?.message} isPageLoad={true} click={count}/>}
                        <div className="card-header">
                            {!editProjectButtonToggle ? localization.addProject : localization.editValetProject}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <ConstantInput
                                        label='Project Id'
                                        type="number"
                                        value={inputList.project_id}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'project_id', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                        disabled={freezProjectIdSection}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <center>
                                        <Button onClick={handleOnSubmitSearch}>
                                            {localization.search}
                                        </Button>
                                    </center>
                                </div>
                                {searchProjectRes.length > 0 &&
                                    <>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={localization.projectName}
                                                type="text"
                                                value={searchProjectRes[0].project.name}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'project_name', 0);
                                                }}
                                                required
                                                isStarRequired={true}
                                                disabled={!editProjectButtonToggle}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={localization.address}
                                                type="text"
                                                value={searchProjectRes[0].project.address}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'address', 0);
                                                }}
                                                required
                                                isStarRequired={true}
                                                disabled={!editProjectButtonToggle}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={localization.city}
                                                type="text"
                                                value={searchProjectRes[0].project.city}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'city', 0);
                                                }}
                                                required
                                                isStarRequired={true}
                                                disabled={!editProjectButtonToggle}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={localization.lat}
                                                type="text"
                                                value={searchProjectRes[0].project.latitude}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'latitude', 0);
                                                }}
                                                required
                                                isStarRequired={true}
                                                disabled={!editProjectButtonToggle}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={localization.lng}
                                                type="text"
                                                value={searchProjectRes[0].project.longitude}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'longitude', 0);
                                                }}
                                                required
                                                isStarRequired={true}
                                                disabled={!editProjectButtonToggle}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={localization.zoneSelectionType}
                                                type="text"
                                                value={searchProjectRes[0].project?.project_config_json?.zone_selection_type}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'zone_selection_type', 0);
                                                }}
                                                required
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={localization.eta}
                                                type="number"
                                                value={searchProjectRes[0].project?.project_config_json?.eta}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'eta', 0);
                                                }}
                                                required
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={localization.gmcMandatoryCount}
                                                type="number"
                                                value={searchProjectRes[0].project?.project_config_json?.gmc_mandatory_count}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'gmc_mandatory_count');
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={localization.operationStartDate}
                                                type="time"
                                                value={searchProjectRes[0].project?.project_config_json?.operational_start_time}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'operational_start_time');
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={localization.operationEndDate}
                                                type="time"
                                                value={searchProjectRes[0].project?.project_config_json?.operational_end_time}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'operational_end_time');
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <ConstantInput
                                                label={'Project Radius'}
                                                type="text"
                                                value={searchProjectRes[0].project?.project_config_json?.project_radius}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'project_radius');
                                                }}
                                                required
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-5">
                                            <input className="form-check-input" type="checkbox"
                                                   value={inputList.allow_get_my_car}
                                                   onChange={e => handleChange(e, 'allow_get_my_car')}
                                                   checked={inputList[0].allow_get_my_car}
                                                   style={{'marginLeft':"15%"}}
                                                   required/>
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.allowGetMyCar}</label>
                                        </div>
                                        <div className="col-md-4 mb-5">
                                            <input className="form-check-input" type="checkbox"
                                                   value={inputList.allow_arrived_notification}
                                                   onChange={e => handleChange(e, 'allow_arrived_notification')}
                                                   checked={inputList[0].allow_arrived_notification}
                                                   style={{'marginLeft':"15%"}}
                                                   required/>
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.allowArrivedNotification}</label>
                                        </div>
                                        <div className="col-md-4 mb-5">
                                            <input className="form-check-input" type="checkbox"
                                                   value={inputList.allow_delivered_notification}
                                                   onChange={e => handleChange(e, 'allow_delivered_notification')}
                                                   checked={inputList[0].allow_delivered_notification}
                                                       style={{'marginLeft':"15%"}}
                                                   required/>
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.allowDeliveryNotification}</label>
                                        </div>
                                        <div className="col-md-4 mb-5">
                                            <input className="form-check-input" type="checkbox"
                                                   value={inputList.allow_parked_notification}
                                                   onChange={e => handleChange(e, 'allow_parked_notification')}
                                                   checked={inputList[0].allow_parked_notification}
                                                       style={{'marginLeft':'15%'}}
                                                   required/>
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.allowParkedNotification}</label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input className="form-check-input m3-3" type="checkbox"
                                                   value={inputList.pre_payment}
                                                   onChange={e => handleChange(e, 'pre_payment')}
                                                   checked={inputList[0].pre_payment}
                                                       style={{'marginLeft':"15%"}}
                                                   required/>
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.prePayment}</label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input className="form-check-input m3-3" type="checkbox"
                                                   value={inputList.is_saas}
                                                   onChange={e => handleChange(e, 'is_saas')}
                                                   checked={inputList[0].is_saas}
                                                   style={{'marginLeft':"15%"}}
                                                   required/>
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.isSaas}</label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input className="form-check-input m3-3" type="checkbox"
                                                   value={inputList.is_image_skippable_site}
                                                   checked={inputList[0].is_image_skippable_site}
                                                   onChange={e => handleChange(e, 'is_image_skippable_site')}
                                                   style={{"marginLeft":"15%"}}
                                                   required/>
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.isImageSkippableSite}</label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input className="form-check-input m3-3" type="checkbox"
                                                   value={inputList.is_prebooking_allowed}
                                                   checked={inputList[0].is_prebooking_allowed}
                                                   onChange={e => handleChange(e, 'is_prebooking_allowed')}
                                                   style={{"marginLeft":"15%"}}
                                                   />
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.isPrebookingAllowed}</label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input className="form-check-input m3-3" type="checkbox"
                                                   value={inputList.is_insurance_allowed}
                                                   checked={inputList[0].is_insurance_allowed}
                                                   onChange={e => handleChange(e, 'is_insurance_allowed')}
                                                   style={{"marginLeft":"15%"}}
                                            />
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.isInsuranceAllowed}</label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input className="form-check-input m3-3" type="checkbox"
                                                   value={inputList.allow_prebook_otp}
                                                   checked={inputList[0].allow_prebook_otp}
                                                   onChange={e => handleChange(e, 'allow_prebook_otp')}
                                                   style={{"marginLeft":"15%"}}
                                            />
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.allowPrebookOtp}</label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input className="form-check-input m3-3" type="checkbox"
                                                   value={inputList.allow_delivery_otp}
                                                   checked={inputList[0].allow_delivery_otp}
                                                   onChange={e => handleChange(e, 'allow_delivery_otp')}
                                                   style={{"marginLeft":"15%"}}
                                            />
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.allowDeliveryOtp}</label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input className="form-check-input m3-3" type="checkbox"
                                                   value={inputList.is_vrn_validation_required}
                                                   checked={inputList[0].is_vrn_validation_required}
                                                   onChange={e => handleChange(e, 'is_vrn_validation_required')}
                                                   style={{"marginLeft":"15%"}}
                                                   required/>
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.isVrnValidationRequired}</label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input className="form-check-input m3-3" type="checkbox"
                                                   value={inputList.show_pms_entered_vehicle}
                                                   checked={inputList[0].show_pms_entered_vehicle}
                                                   onChange={e => handleChange(e, 'show_pms_entered_vehicle')}
                                                   style={{"marginLeft":"15%"}}
                                                   required/>
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{localization.showPmsEnteredVehicles}</label>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <input className="form-check-input m3-3" type="checkbox"
                                                   value={inputList.is_punched}
                                                   onChange={e => handleChange(e, 'is_punched')}
                                                   checked={inputList[0].is_punched}
                                                   style={{'marginLeft':"15%"}}
                                                   required/>
                                            <label className="form-check-label"
                                                   htmlFor="flexCheckChecked">{'Is auto punched out allowed'}</label>
                                        </div>
                                        <div className="col-md-5 mb-3">
                                            <DropDownInput

                                                data={[
                                                    {id: 'online', name: 'Online'},
                                                    {id: 'site_online', name: 'Site Online'},
                                                    {id: 'foc', name: 'Foc'},
                                                    {id: 'cash', name: 'Cash'},
                                                ]}
                                                label={localization.pmcAllowedPaymentMethod}
                                                required
                                                isStarRequired={true}
                                                multipule={true}
                                                getIdValue={(val) => {
                                                    setPmcAllowedMethod(val)
                                                }}
                                                selectedList={searchProjectRes[0].project?.pmc}
                                            />
                                        </div>
                                        <div className="col-md-5 mb-3">
                                            <DropDownInput
                                                data={[
                                                    {id: 'online', name: 'Online'},
                                                    {id: 'site_online', name: 'Site Online'},
                                                    {id: 'foc', name: 'Foc'},
                                                    {id: 'cash', name: 'Cash'},
                                                ]}
                                                label={localization.gmcAllowedPaymentMethod}
                                                required
                                                isStarRequired={true}
                                                multipule={true}
                                                getIdValue={(val) => {
                                                    setGmcAllowedMethod(val)
                                                }}
                                                selectedList={searchProjectRes[0].project?.gmc}
                                            />
                                        </div>
                                        <div className="col-md-5 mb-3">
                                            <DropDownInput
                                                data={[
                                                    {id: 0, name: 'Sunday'},
                                                    {id: 1, name: 'Monday'},
                                                    {id: 2, name: 'Tuesday'},
                                                    {id: 3, name: 'Wednesday'},
                                                    {id: 4, name: 'thursday'},
                                                    {id: 5, name: 'Friday'},
                                                    {id: 6, name: 'Saturday'},
                                                    {id: 10, name: 'Holiday'},
                                                ]}
                                                label={localization.operationDays}
                                                multipule={true}
                                                getIdValue={(val) => {
                                                    setOperationalDays(val)
                                                }}
                                                selectedList={searchProjectRes[0].project?.operational_days}
                                            />
                                        </div>
                                        <div className="col-md-5 mb-3">
                                            <DropDownInput
                                                data={[
                                                    {id: 'default', name: 'Default'},
                                                    {id: 'merger', name: 'Merger'},
                                                    {id: 'non_number', name: 'Non Number'},
                                                ]}
                                                label={localization.flowTypes}
                                                getIdValue={(val) => {
                                                    handleInputValue(val?.id, 'flow_type')
                                                }}
                                                // selectedList={searchProjectRes[0]?.project?.flow_type}
                                                value={searchProjectRes[0].project?.project_config_json?.flow_type}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-md-5 mb-3">
                                            <DropDownInput
                                                data={[
                                                    {id: 'valet', name: 'Valet'},
                                                    {id: 'dealer', name: 'Dealer'},
                                                ]}
                                                label={localization.businessType}
                                                getIdValue={(val) => {
                                                    handleInputValue(val?.id, 'business_type')
                                                }}
                                                // selectedList={searchProjectRes[0].project?.business_type}
                                                value={searchProjectRes[0].project?.project_config_json?.business_type}
                                            />
                                        </div>
                                        <div className="col-md-5 mb-3">
                                            <DropDownInput
                                                data={[
                                                    {id: 0, name: "0"},
                                                    {id: 1, name: "1"},
                                                    {id: 2, name: "2"},
                                                ]}
                                                label={localization.passTypeApplication}
                                                getIdValue={(val) => {
                                                    handleInputValue(val?.id, 'pass_type_applicable')
                                                }}
                                                
                                                value={String(searchProjectRes[0].project?.project_config_json?.pass_type_applicable !== undefined ? searchProjectRes[0].project?.project_config_json?.pass_type_applicable : "")}
                                            />
                                        </div>
                                        <div className="col-md-5 mb-3">
                                            <DropDownInput
                                                data={[
                                                    {id: "Roster", name: "Roster"},
                                                    {id: "Normal", name: "Normal"}
                                                ]}
                                                label={localization.dutyMode}
                                                getIdValue={(val) => {
                                                    handleInputValue(val?.id, 'duty_mode')
                                                }}
                                                value={String(searchProjectRes[0].project?.project_config_json?.duty_mode !== undefined ? searchProjectRes[0].project?.project_config_json?.duty_mode : "")}
                                                required={true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                                    <ConstantInput
                                                        label={'Platform Fees'}
                                                        type="number"
                                                        value={projectPricing?.monday?.platform_fee}
                                                        handleChange={(val) => {
                                                            handleInputValue(val, 'platform_fee', 0);
                                                        }}
                                                        required
                                                        isStarRequired={true}
                                                    />
                                                </div>
                                        
                                            {
                                                searchProjectRes[0].project?.project_config_json?.project_type=='event' ? (
                                                    <>
                                                    <div className="col-md-4">
                                                            <ConstantInput
                                                                label={'Project Type'}
                                                                type="text"
                                                                value={searchProjectRes[0].project?.project_config_json?.project_type}
                                                                disabled={true}
                                                                required
                                                                isStarRequired={true}
                                                            />
                                                        </div>
                                                        
                                                        <div className="col-md-4">
                                                            <input className="form-check-input m3-3" type="checkbox"
                                                                    checked={inputList[0].active}
                                                                    onChange={e => handleChange(e, 'active')}
                                                                    style={{"marginLeft":"15%"}}
                                                                    required/>
                                                            <label className="form-check-label"
                                                                htmlFor="flexCheckChecked">{'Active'}</label>
                                                        </div>
                                                    </>
                                                ):(
                                                    <>
                                                    <div className="col-md-4">
                                                        <input className="form-check-input m3-3" type="checkbox"
                                                                onChange={e => handleChange(e, 'is_event')}
                                                                required/>
                                                        <label className="form-check-label"
                                                            htmlFor="flexCheckChecked">{'Is Event'}</label>
                                                    </div>
                                                    </>
                                                )
                                            }                                    
                                        {inputImage.map((x, i) => {
                                            return (
                                                <>
                                                    <div className="col-md-3 col-sm-8">
                                                        <FileUpload
                                                            id={"addAttachment" + i}
                                                            accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                            documentUploadUrl={documentUploadUrlPublic}
                                                            documentUrlData={documentUrlDataPublic}
                                                            onChange={(val) =>
                                                                saveImage(val, i)
                                                            }
                                                            prefilledFilename={x?.url ? 'Image uploaded' : ""}
                                                        >
                                                        <span className="btn btn-transparent">
                                                            {localization.image}
                                                        </span>
                                                        </FileUpload>
                                                    </div>
                                                    {x?.url &&
                                                        <div className="col-md-2 col-sm-8" >
                                                            <img src={x?.url} style={{"width":"80px", "borderRadius":"16px", "height":"57px"}}/>
                                                        </div>
                                                    }
                                                    <div className="col-md-4 col-sm-8">
                                                        <ConstantInput
                                                            label={localization.caption}
                                                            type="text"
                                                            value={x?.content}
                                                            handleChange={(val) => {
                                                                handleImageContent(val, i);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    {inputImage.length !== 1 &&
                                                        <div className="col-md-2 col-sm-5">
                                                            <button
                                                                onClick={() => handleImageRemove(i)}
                                                                className="mr10 btn btn-sm btn-danger">Remove
                                                            </button>
                                                        </div>
                                                    }
                                                    {inputImage.length - 1 === i &&
                                                        <div className="col-md-2 col-sm-5">
                                                            <button className="btn btn-sm btn-primary"
                                                                    onClick={handleImageAdd}>Add
                                                            </button>
                                                        </div>
                                                    }
                                        </>
                                            );
                                        })}

                                        <>
                                            <div className="col-md-4 mb-3">
                                                <input className="form-check-input m3-3" type="checkbox"
                                                       value={inputList.is_progressive}
                                                       checked={inputList[0].is_progressive}
                                                       onChange={e => handleChange(e, 'is_progressive')}
                                                       required/>
                                                <label className="form-check-label"
                                                       htmlFor="flexCheckChecked">{localization.isProgressive}</label>
                                            </div>
                    
                                            {/* <div className="col-md-4 mt-5">
                                                <input className="form-check-input m3-3" type="checkbox"
                                                    value={inputList.is_platform_fee_allowed}
                                                    onChange={e => handleChange(e, 'is_platform_fee_allowed')}
                                                    checked={inputList[0].is_platform_fee_allowed}
                                                    style={{'marginLeft':"15%"}}
                                                    required/>
                                                <label className="form-check-label"
                                                    htmlFor="flexCheckChecked">{'Is platform fees allowed'}</label>
                                            </div> */}
                                            {/* {isPlatformFeeAllowed  && ( */}
                                                {/* <div className="col-md-4">
                                                    <ConstantInput
                                                        label={'Platform Fees'}
                                                        type="number"
                                                        value={searchProjectRes[0].project?.project_config_json?.platform_fee}
                                                        handleChange={(val) => {
                                                            handleInputValue(val, 'platform_fee', 0);
                                                        }}
                                                        required
                                                        isStarRequired={true}
                                                    />
                                                </div> */}
                                            {/* )} */}
                                          
                                            <div className="container col-lg-12"
                                            >
                                                <div className="col-md-12" style={{
                                                    "borderTop": "1px solid #6c7ae0",
                                                    "borderBottom": "1px solid #6c7ae0",
                                                    "paddingTop": "2%", "borderRadius": "10px",
                                                    "marginBottom": "3%",
                                                    'marginTop':"3%"
                                                }}>
                                                    <p style={{"color":"#6c7ae0", "fontWeight":"900"}}>{localization.sundayPrice}</p>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.sundayPrice}
                                                            type="number"
                                                            value={projectPricing?.sunday?.price}
                                                            handleChange={(val) => {
                                                                handleInputPrice(val, '0');
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.baseHours}
                                                            type="number"
                                                            value={projectPricing?.sunday?.base_hour}
                                                            handleChange={(val) => {
                                                                handleBaseHour(val, 0);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                            max={"24"}
                                                            min={"1"}
                                                        />
                                                    </div>
                                                    {isSaasSet &&
                                                        <>
                                                            <div className="col-md-12">
                                                                <p>{localization.ProgressiveCharge}</p>
                                                                {sundayprogressiveCharge.map((v, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="col-md-4"
                                                                                 key={i + 1}>
                                                                                <ConstantInput
                                                                                    label={localization.hours}
                                                                                    type="number"
                                                                                    value={v?.hours}
                                                                                    handleChange={(val) => {
                                                                                        handleSundayProgressiveChargeValue(val, 'hours', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4"
                                                                                 key={i + 2}>
                                                                                <ConstantInput
                                                                                    label={localization.price}
                                                                                    type="number"
                                                                                    value={v?.price}
                                                                                    handleChange={(val) => {
                                                                                        handleSundayProgressiveChargeValue(val, 'price', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="btn-box mb-4">
                                                                                {sundayprogressiveCharge.length !== 1 &&
                                                                                    <button
                                                                                        onClick={() => handleSundayProgressiveChargeValueRemove(i)}
                                                                                        className="btn btn-sm btn-danger mr10">Remove
                                                                                    </button>}
                                                                                {sundayprogressiveCharge.length - 1 === i &&
                                                                                    <button
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() => handleSundayProgressiveChargeValueAdd()}>Add
                                                                                    </button>}
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <div className="col-md-12" style={{
                                                    "borderTop": "1px solid #6c7ae0",
                                                    "borderBottom": "1px solid #6c7ae0",
                                                    "paddingTop": "2%", "borderRadius": "10px",
                                                    "marginBottom": "3%",
                                                    'marginTop':"3%"
                                                }}>
                                                    <p style={{"color":"#6c7ae0", "fontWeight":"900"}}>{localization.mondayPrice}</p>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.mondayPrice}
                                                            type="number"
                                                            value={projectPricing?.monday?.price}
                                                            handleChange={(val) => {
                                                                handleInputPrice(val, 1);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.baseHours}
                                                            type="number"
                                                            value={projectPricing?.monday?.base_hour}
                                                            handleChange={(val) => {
                                                                handleBaseHour(val, 1);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    {isSaasSet &&
                                                        <>
                                                            <div className="col-md-12">
                                                                <p>{localization.ProgressiveCharge}</p>
                                                                {mondayprogressiveCharge.map((v, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="col-md-4"
                                                                                 key={i + 1}>
                                                                                <ConstantInput
                                                                                    label={localization.hours}
                                                                                    type="number"
                                                                                    value={v?.hours}
                                                                                    handleChange={(val) => {
                                                                                        handleMondayProgressiveChargeValue(val, 'hours', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4"
                                                                                 key={i + 2}>
                                                                                <ConstantInput
                                                                                    label={localization.price}
                                                                                    type="number"
                                                                                    value={v?.price}
                                                                                    handleChange={(val) => {
                                                                                        handleMondayProgressiveChargeValue(val, 'price', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="btn-box mb-4">
                                                                                {mondayprogressiveCharge.length !== 1 &&
                                                                                    <button
                                                                                        onClick={() => handleMondayProgressiveChargeValueRemove(i)}
                                                                                        className="btn btn-sm btn-danger mr10">Remove
                                                                                    </button>}
                                                                                {mondayprogressiveCharge.length - 1 === i &&
                                                                                    <button
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() => handleMondayProgressiveChargeValueAdd()}>Add
                                                                                    </button>}
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <div className="col-md-12" style={{
                                                    "borderTop": "1px solid #6c7ae0",
                                                    "borderBottom": "1px solid #6c7ae0",
                                                    "paddingTop": "2%", "borderRadius": "10px",
                                                    "marginBottom": "3%",
                                                    'marginTop':"3%"
                                                }}>
                                                    <p style={{"color":"#6c7ae0", "fontWeight":"900"}}>{localization.tuesdayPrice}</p>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.tuesdayPrice}
                                                            type="number"
                                                            value={projectPricing?.tuesday?.price}
                                                            handleChange={(val) => {
                                                                handleInputPrice(val, '2');
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.baseHours}
                                                            type="number"
                                                            value={projectPricing?.tuesday?.base_hour}
                                                            handleChange={(val) => {
                                                                handleBaseHour(val, 2);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    {isSaasSet &&
                                                        <>
                                                            <div className="col-md-12">
                                                                <p>{localization.ProgressiveCharge}</p>
                                                                {tuesdayprogressiveCharge.map((v, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="col-md-4"
                                                                                 key={i + 1}>
                                                                                <ConstantInput
                                                                                    label={localization.hours}
                                                                                    type="number"
                                                                                    value={v?.hours}
                                                                                    handleChange={(val) => {
                                                                                        handleTuesdayProgressiveChargeValue(val, 'hours', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4"
                                                                                 key={i + 2}>
                                                                                <ConstantInput
                                                                                    label={localization.price}
                                                                                    type="number"
                                                                                    value={v?.price}
                                                                                    handleChange={(val) => {
                                                                                        handleTuesdayProgressiveChargeValue(val, 'price', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="btn-box mb-4">
                                                                                {tuesdayprogressiveCharge.length !== 1 &&
                                                                                    <button
                                                                                        onClick={() => handleTuesdayProgressiveChargeValueRemove(i)}
                                                                                        className="btn btn-sm btn-danger mr10">Remove
                                                                                    </button>}
                                                                                {tuesdayprogressiveCharge.length - 1 === i &&
                                                                                    <button
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() => handleTuesdayProgressiveChargeValueAdd()}>Add
                                                                                    </button>}
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <div className="col-md-12" style={{
                                                    "borderTop": "1px solid #6c7ae0",
                                                    "borderBottom": "1px solid #6c7ae0",
                                                    "paddingTop": "2%", "borderRadius": "10px",
                                                    "marginBottom": "3%",
                                                    'marginTop':"3%"
                                                }}>
                                                    <p style={{"color":"#6c7ae0", "fontWeight":"900"}}>{localization.wednesdayPrice}</p>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.wednesdayPrice}
                                                            type="number"
                                                            value={projectPricing?.wednesday?.price}
                                                            handleChange={(val) => {
                                                                handleInputPrice(val, '3');
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.baseHours}
                                                            type="number"
                                                            value={projectPricing?.wednesday?.base_hour}
                                                            handleChange={(val) => {
                                                                handleBaseHour(val, 3);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    {isSaasSet &&
                                                        <>
                                                            <div className="col-md-12">
                                                                <p>{localization.ProgressiveCharge}</p>
                                                                {wednesdayprogressiveCharge.map((v, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="col-md-4"
                                                                                 key={i + 1}>
                                                                                <ConstantInput
                                                                                    label={localization.hours}
                                                                                    type="number"
                                                                                    value={v?.hours}
                                                                                    handleChange={(val) => {
                                                                                        handleWedProgressiveChargeValue(val, 'hours', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4"
                                                                                 key={i + 2}>
                                                                                <ConstantInput
                                                                                    label={localization.price}
                                                                                    type="number"
                                                                                    value={v?.price}
                                                                                    handleChange={(val) => {
                                                                                        handleWedProgressiveChargeValue(val, 'price', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="btn-box mb-4">
                                                                                {wednesdayprogressiveCharge.length !== 1 &&
                                                                                    <button
                                                                                        onClick={() => handleWedProgressiveChargeValueRemove(i)}
                                                                                        className="btn btn-sm btn-danger mr10">Remove
                                                                                    </button>}
                                                                                {wednesdayprogressiveCharge.length - 1 === i &&
                                                                                    <button
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() => handleWedProgressiveChargeValueAdd()}>Add
                                                                                    </button>}
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <div className="col-md-12" style={{
                                                    "borderTop": "1px solid #6c7ae0",
                                                    "borderBottom": "1px solid #6c7ae0",
                                                    "paddingTop": "2%", "borderRadius": "10px",
                                                    "marginBottom": "3%",
                                                    'marginTop':"3%"
                                                }}>
                                                    <p style={{"color":"#6c7ae0", "fontWeight":"900"}}>{localization.thursdayPrice}</p>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.thursdayPrice}
                                                            type="number"
                                                            value={projectPricing?.thurs?.price}
                                                            handleChange={(val) => {
                                                                handleInputPrice(val, '4');
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.baseHours}
                                                            type="number"
                                                            value={projectPricing?.thurs?.base_hour}
                                                            handleChange={(val) => {
                                                                handleBaseHour(val, 4);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    {isSaasSet &&
                                                        <>
                                                            <div className="col-md-12">
                                                                <p>{localization.ProgressiveCharge}</p>
                                                                {thurprogressiveCharge.map((v, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="col-md-4"
                                                                                 key={i + 1}>
                                                                                <ConstantInput
                                                                                    label={localization.hours}
                                                                                    type="number"
                                                                                    value={v?.hours}
                                                                                    handleChange={(val) => {
                                                                                        handleThurProgressiveChargeValue(val, 'hours', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4"
                                                                                 key={i + 2}>
                                                                                <ConstantInput
                                                                                    label={localization.price}
                                                                                    type="number"
                                                                                    value={v?.price}
                                                                                    handleChange={(val) => {
                                                                                        handleThurProgressiveChargeValue(val, 'price', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="btn-box mb-4">
                                                                                {thurprogressiveCharge.length !== 1 &&
                                                                                    <button
                                                                                        onClick={() => handleThurProgressiveChargeValueRemove(i)}
                                                                                        className="btn btn-sm btn-danger mr10">Remove
                                                                                    </button>}
                                                                                {thurprogressiveCharge.length - 1 === i &&
                                                                                    <button
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() => handleThurProgressiveChargeValueAdd()}>Add
                                                                                    </button>}
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <div className="col-md-12" style={{
                                                    "borderTop": "1px solid #6c7ae0",
                                                    "borderBottom": "1px solid #6c7ae0",
                                                    "paddingTop": "2%", "borderRadius": "10px",
                                                    "marginBottom": "3%",
                                                    'marginTop':"3%"
                                                }}>
                                                    <p style={{"color":"#6c7ae0", "fontWeight":"900"}}>{localization.fridayPrice}</p>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.fridayPrice}
                                                            type="number"
                                                            value={projectPricing?.friday?.price}
                                                            handleChange={(val) => {
                                                                handleInputPrice(val, '5');
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 price_week ">
                                                        <ConstantInput
                                                            label={localization.baseHours}
                                                            type="number"
                                                            value={projectPricing?.friday?.base_hour}
                                                            handleChange={(val) => {
                                                                handleBaseHour(val, 5);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    {isSaasSet &&
                                                        <>
                                                            <div className="col-md-12">
                                                                <p>{localization.ProgressiveCharge}</p>
                                                                {friprogressiveCharge.map((v, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="col-md-4"
                                                                                 key={i + 1}>
                                                                                <ConstantInput
                                                                                    label={localization.hours}
                                                                                    type="number"
                                                                                    value={v?.hours}
                                                                                    handleChange={(val) => {
                                                                                        handleFriProgressiveChargeValue(val, 'hours', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4"
                                                                                 key={i + 2}>
                                                                                <ConstantInput
                                                                                    label={localization.price}
                                                                                    type="number"
                                                                                    value={v?.price}
                                                                                    handleChange={(val) => {
                                                                                        handleFriProgressiveChargeValue(val, 'price', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="btn-box mb-4">
                                                                                {friprogressiveCharge.length !== 1 &&
                                                                                    <button
                                                                                        onClick={() => handleFriProgressiveChargeValueRemove(i)}
                                                                                        className="btn btn-sm btn-danger mr10">Remove
                                                                                    </button>}
                                                                                {friprogressiveCharge.length - 1 === i &&
                                                                                    <button
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() => handleFriProgressiveChargeValueAdd()}>Add
                                                                                    </button>}
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <div className="col-md-12" style={{
                                                    "borderTop": "1px solid #6c7ae0",
                                                    "borderBottom": "1px solid #6c7ae0",
                                                    "paddingTop": "2%", "borderRadius": "10px",
                                                    "marginBottom": "3%",
                                                    'marginTop':"3%"
                                                }}>
                                                    <p style={{"color":"#6c7ae0", "fontWeight":"900"}}>{localization.saturdayPrice}</p>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.saturdayPrice}
                                                            type="number"
                                                            value={projectPricing?.sat?.price}
                                                            handleChange={(val) => {
                                                                handleInputPrice(val, 6);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.baseHours}
                                                            type="number"
                                                            value={projectPricing?.sat?.base_hour}
                                                            handleChange={(val) => {
                                                                handleBaseHour(val, 6);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    {isSaasSet &&
                                                        <>
                                                            <div className="col-md-12">
                                                                <p>{localization.ProgressiveCharge}</p>
                                                                {satprogressiveCharge.map((v, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="col-md-4"
                                                                                 key={i + 1}>
                                                                                <ConstantInput
                                                                                    label={localization.hours}
                                                                                    type="number"
                                                                                    value={v?.hours}
                                                                                    handleChange={(val) => {
                                                                                        handleSatProgressiveChargeValue(val, 'hours', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4"
                                                                                 key={i + 2}>
                                                                                <ConstantInput
                                                                                    label={localization.price}
                                                                                    type="number"
                                                                                    value={v?.price}
                                                                                    handleChange={(val) => {
                                                                                        handleSatProgressiveChargeValue(val, 'price', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="btn-box mb-4">
                                                                                {satprogressiveCharge.length !== 1 &&
                                                                                    <button
                                                                                        onClick={() => handleSatProgressiveChargeValueRemove(i)}
                                                                                        className="btn btn-sm btn-danger mr10">Remove
                                                                                    </button>}
                                                                                {satprogressiveCharge.length - 1 === i &&
                                                                                    <button
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() => handleSatProgressiveChargeValueAdd()}>Add
                                                                                    </button>}
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <div className="col-md-12" style={{
                                                    "borderTop": "1px solid #6c7ae0",
                                                    "borderBottom": "1px solid #6c7ae0",
                                                    "paddingTop": "2%", "borderRadius": "10px",
                                                    "marginBottom": "3%",
                                                    'marginTop':"3%"
                                                }}>
                                                    <p style={{"color":"#6c7ae0", "fontWeight":"900"}}>{localization.holidayPrice}</p>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.holidayPrice}
                                                            type="number"
                                                            value={projectPricing?.holiday?.price}
                                                            handleChange={(val) => {
                                                                handleInputPrice(val, 10);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 price_week">
                                                        <ConstantInput
                                                            label={localization.baseHours}
                                                            type="number"
                                                            value={projectPricing?.holiday?.base_hour}
                                                            handleChange={(val) => {
                                                                handleBaseHour(val, 10);
                                                            }}
                                                            required
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                    {isSaasSet &&
                                                        <>
                                                            <div className="col-md-12">
                                                                <p>{localization.ProgressiveCharge}</p>
                                                                {holidayprogressiveCharge.map((v, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="col-md-4"
                                                                                 key={i + 1}>
                                                                                <ConstantInput
                                                                                    label={localization.hours}
                                                                                    type="number"
                                                                                    value={v?.hours}
                                                                                    handleChange={(val) => {
                                                                                        handleHolidayProgressiveChargeValue(val, 'hours', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4"
                                                                                 key={i + 2}>
                                                                                <ConstantInput
                                                                                    label={localization.price}
                                                                                    type="number"
                                                                                    value={v?.price}
                                                                                    handleChange={(val) => {
                                                                                        handleHolidayProgressiveChargeValue(val, 'price', i);
                                                                                    }}
                                                                                    required
                                                                                    isStarRequired={true}
                                                                                />
                                                                            </div>
                                                                            <div className="btn-box mb-4">
                                                                                {holidayprogressiveCharge.length !== 1 &&
                                                                                    <button
                                                                                        onClick={() => handleHolidayProgressiveChargeValueRemove(i)}
                                                                                        className="btn btn-sm btn-danger mr10">Remove</button>}
                                                                                {holidayprogressiveCharge.length - 1 === i &&
                                                                                    <button
                                                                                        className="btn btn-sm btn-primary"
                                                                                        onClick={() => handleHolidayProgressiveChargeValueAdd()}>Add
                                                                                    </button>}
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </>

                                        <div className="col-md-12">
                                            <center><Button onClick={handleOnSubmitForm}>
                                                {!editProjectButtonToggle ? localization.submitDtl : localization.updateValetProject}
                                            </Button>
                                            </center>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};
export default Projects
